import React from 'react'
import "./PrivacyPolicy.css"
export default function TermsPage() {
  return (
    <div class="policy-container">
    <div className='privacyheader'>
        <h1>Terms & Conditions</h1>
    </div>

    <section class="terms-content">
        <h2>Introduction</h2>
        <p>Welcome to [Social Software Name]. These Terms & Conditions govern your use of our website and services. By accessing or using our services, you agree to be bound by these terms.</p>

        <h2>Use of Services</h2>
        <p>You agree to use our services only for lawful purposes and in a way that does not infringe the rights of others. You must not:</p>
        <ul>
            <li>Engage in any fraudulent, harmful, or illegal activity.</li>
            <li>Attempt to gain unauthorized access to our systems.</li>
            <li>Disrupt or interfere with the functionality of our services.</li>
        </ul>

        <h2>Account Registration</h2>
        <p>You may need to create an account to access certain features of our services. You are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account.</p>

        <h2>Intellectual Property</h2>
        <p>All content, trademarks, and other intellectual property on our website and services are owned by or licensed to [Social Software Name]. You may not use our intellectual property without our prior written consent.</p>

        <h2>Termination</h2>
        <p>We reserve the right to terminate or suspend your access to our services at any time, without notice, for conduct that we believe violates these Terms & Conditions or is harmful to other users or us.</p>

        <h2>Limitation of Liability</h2>
        <p>We are not liable for any damages arising from your use of our services. Our total liability for any claims related to our services is limited to the amount you paid us in the last 12 months.</p>

        <h2>Changes to Terms</h2>
        <p>We may update these Terms & Conditions from time to time. Any changes will be posted on this page, and your continued use of our services after such changes indicates your acceptance of the new terms.</p>

        <h2>Governing Law</h2>
        <p>These Terms & Conditions are governed by the laws of [Country/State]. Any disputes arising from these terms will be resolved in the courts of [Country/State].</p>

        <h2>Contact Us</h2>
        <p>If you have any questions about these Terms & Conditions, please contact us at <a href="mailto:support@socialsoftware.com">support@socialsoftware.com</a>.</p>
    </section>

    <footer>
        <p>&copy; 2024 [Dellife]. All rights reserved.</p>
    </footer>
</div>
  )
}
